import http from "./http.js";

async function login(username, password) {
  try {
    const response = await http.post("token", {
      username,
      password,
    });
    return response.data;
    // return http({
    //   url: "/token",
    //   method: "post",
    //   data:
    // `grant_type=password&username=${username}&password=${password}`,
    // headers: {
    //   "Content-type": "application/x-www-form-urlencoded"
    // }
    // })
  } catch (err) {
    throw err;
  }
}
export { login };
